module.exports = __webpack_public_path__ + "media/images/USA-matrimony-banner3-171f8c25c1a50032e9e9fd02908d5407.jpg";